import { asType } from '@sparky/framework'
import { ActivationManifest, PrimaryAppIds } from '../renderer'
import { DAS_BANNER_MESSAGE } from '../constants'

export default asType<ActivationManifest>({
  activation_id: 'aiops',
  description: 'AIOps for NGFW',
  primary_app_id: PrimaryAppIds.STRATA_INSIGHTS,
  flags: {
    hash_required: true,
    cdl_required: true,
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.DefaultActivateScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.ScreenHeader',
            props: {
              title: 'Activate AIOps For NGFW Premium',
              subTitle: ''
            }
          },
          {
            key: 'ela-header',
            component: 'activation.ElaLicenseInfo',
            props: {
            }
          },
          {
            key: 'activation-form',
            component: 'activation.DefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'default-dropdown-component',
                  component: 'activation.DefaultActivationCommonDropdowns',
                  props: {
                    group: 1, // used for grouping elemenets/children to apply common properties such as style.
                    children: [
                      {
                        key: 'default-tsg-component',
                        component: 'activation.TSGDropDown',
                        props: {
                          create_new: true,
                          showAllTSG: true,
                          display: {
                            errorMessage: 'Select TSG to proceed activation',
                            toolTipMessage: 'Select the TSG where the license needs to be provisioned',
                            subTitle: 'The tenant where the license will be activated'
                          },
                          dropDownProps: {
                            required: true,
                            addNewValue: true,
                            triggerValidationOnChange: true,
                            addNewProps: {
                              conditionValue: 'ADD_NEW',
                              updatedValue: '',
                              createValue: '[Create New]'
                            }
                          },
                          size: {
                            height: 32,
                            width: 300
                          },
                          passByProps: {
                            enableSearch: true,
                            label: 'Tenant',
                            dataMetrics: 'default-tsg-component',
                            dataTestId: 'tsg-activation-screen',
                            placeholder: 'Select Tenant / Create New',
                            menuStyle: { width: 300 }
                          }
                        }
                      },
                      {
                        key: 'default-csp-component',
                        component: 'activation.CSPDropDownWrapper',
                        props: {
                          display: {
                            subTitle: 'Customer support account for this tenant'
                          },
                        }
                      },
                      {
                        key: 'default-region-component',
                        component: 'activation.RegionDropDown',
                        props: {
                          header: true,
                          display: {
                            subTitle: 'Deployment region and where your data logs are stored'
                          },
                        }
                      }
                    ]
                  },
                },
                {
                  key: 'default-divider-component',
                  component: 'activation.DividerLine',
                  props: {}
                },
                {
                  key: 'default-license-details-component',
                  component: 'activation.DefaultPrimaryLicenseDetails',
                  props: {
                    group: 1,
                  }
                },
                {
                  key: 'default-divider-component',
                  component: 'activation.DividerLine',
                  props: {}
                },
                {
                  key: 'default-cdl-field',
                  component: 'activation.DefaultCDLField',
                  props: {
                    group: 1,
                    cdlDropDownProps: {
                      display: {
                        errorMessage: 'Select SLS to proceed activation',
                        subTitle: 'SLS instance for this tenant'
                      },
                      dropDownProps: {
                        required: true,
                        triggerValidationOnChange: true,
                      },
                      size: {
                        height: 32,
                        width: 355
                      },
                      passByProps: {
                        // disabled: true,
                        dataTestId: 'cdl-activation-screen',
                        enableSearch: true,
                        label: '',
                        placeholder: 'Select SLS Instance',
                      }
                    },
                  }
                },
                {
                  key: 'default-divider-component',
                  component: 'activation.DividerLine',
                  props: {}
                },
                {
                  key: 'default-cie-field',
                  component: 'activation.DefaultCIEField',
                  props: {
                    group: 1,
                    cieDropDownProps: {
                      display: {
                        errorMessage: 'Select CIE to proceed activation',
                        subTitle: 'CIE instance for this tenant'
                      },
                      dropDownProps: {
                        required: true,
                        triggerValidationOnChange: true,
                      },
                      size: {
                        height: 32,
                        width: 355
                      },
                      passByProps: {
                        dataTestId: 'cie-activation-screen',
                        enableSearch: false,
                        label: '',
                        placeholder: 'Select CIE Instance',
                      }
                    }
                  }
                },
                {
                  key: 'default-divider-component',
                  component: 'activation.DividerLine',
                  props: {}
                },
                {
                  key: 'activation-banner',
                  component: 'activation.ActivationBanner',
                  props: {
                    group: 1,
                    appearance: 'standard',
                    type: 'inline',
                    infoMessage: DAS_BANNER_MESSAGE,
                  }
                },
                {
                  key: 'default-divider-component',
                  component: 'activation.DividerLine',
                  props: {}
                },
                {
                  key: 'instance-table',
                  component: 'activation.InstanceTable',
                  props: {
                    group: 2,
                    title: 'Active Subscriptions',
                    subTitle: ''
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                },
              ],
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
